export const SUSPEND_PARTNER = gql`
    mutation SuspendPartner($id: Int!, $suspendReasonDescription: String!) {
        suspendPartner(id: $id, suspendReasonDescription: $suspendReasonDescription) {
            id
            status
        }
    }
`;

export const UN_SUSPEND_PARTNER = gql`
    mutation UnSuspendPartner($id: Int!) {
        unSuspendPartner(id: $id) {
            id
            status
        }
    }
`;
export const UPDATE_PARTNER_LOGO = gql`
    mutation updatePartnerLogo($input: UpdatePartnerLogoInput) {
        updatePartnerLogo(input: $input) {
            id
        }
    }
`;
export const UPDATE_PARTNER_OF_PARTNER_LOGO = gql`
    mutation updatePartnerOfPartnerLogo($input: UpdatePartnerOfPartnerLogoInput) {
        updatePartnerOfPartnerLogo(input: $input) {
            id
        }
    }
`;

export const UPDATE_PARTNER_BRANDING_COLOUR = gql`
    mutation updatePartnerBrandingColour($input: UpdatePartnerBrandingColourInput) {
        updatePartnerBrandingColour(input: $input)
    }
`;
export const UPDATE_PARTNER_CUSTOM_TERMS = gql`
    mutation updatePartnerCustomTerms($input: UpdatePartnerCustomTermsInput) {
        updatePartnerCustomTerms(input: $input)
    }
`;

export const CREATE_PARTNER_ACCOUNTING_CONNECTION = gql`
    mutation CreatePartnerAccountingConnection($input: CreateAccountingConnectionInput!) {
        createPartnerAccountingConnection(input: $input)
    }
`;
